/**
 * useSession.js
 * New hook. Previously AuthContainer.js called tokenStore.set(...)
 * directly. Centralizing that here means AuthenticationPage only calls
 * `establishSession(token)` — it doesn't need to know tokens are
 * stored in localStorage at all.
 */

import { useCallback } from "react";
import { sessionStorageService } from "../services/session.storage";

export function useSession() {
    const establishSession = useCallback((token) => {
        sessionStorageService.set(token);
    }, []);

    const clearSession = useCallback(() => {
        sessionStorageService.remove();
    }, []);

    const getToken = useCallback(() => sessionStorageService.get(), []);

    return { establishSession, clearSession, getToken };
}
